import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8efc8a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("nav", {
  style: {"--bs-breadcrumb-divider":"'•'"},
  "aria-label": "breadcrumb"
}, [
  /*#__PURE__*/_createElementVNode("ol", { class: "breadcrumb mb-0" }, [
    /*#__PURE__*/_createElementVNode("li", {
      class: "breadcrumb-item active",
      "aria-current": "page"
    }, "Главная")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "pt-4" }, "Что такое ModBox?", -1))
const _hoisted_5 = { class: "text-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Добро пожаловать на "),
  /*#__PURE__*/_createElementVNode("b", null, "Modbox"),
  /*#__PURE__*/_createTextVNode(" — ваш универсальный и надежный источник "),
  /*#__PURE__*/_createElementVNode("b", null, "модификаций для игр"),
  /*#__PURE__*/_createTextVNode(" Assetto Corsa " + " и BeamNG Drive! На нашем сайте вы найдете огромное разнообразие модификаций по интересующим категориям. Мы стремимся предоставить вам всё необходимое для того, чтобы ваш игровой опыт еще более захватывающим и разнообразным.")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "модификации", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "моды для игр", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "модов", -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<h5 class=\"pt-4\" data-v-8efc8a04>Отказ от ответственности</h5><div class=\"text-box\" data-v-8efc8a04><p data-v-8efc8a04>Мы не берем на себя ответственность за любые убытки, проблемы или конфликты, возникающие в результате использования контента, доступного на нашей платформе. Рекомендуем всем пользователям проявлять осторожность и осмотрительность при взаимодействии с файлами на <b data-v-8efc8a04>mod-box.ru.</b><br data-v-8efc8a04><br data-v-8efc8a04> Каждый пользователь несет полную ответственность за контент, который он загружает, скачивает или к которому имеет доступ на нашей платформе. Рекомендуем всем пользователям проявлять осторожность и осмотрительность при взаимодействии с файлами на <b data-v-8efc8a04>mod-box.ru</b>. <br data-v-8efc8a04><br data-v-8efc8a04> Используя нашу платформу, вы автоматически соглашаетесь с этими условиями и обязуетесь вести себя ответственно и этично. <br data-v-8efc8a04><br data-v-8efc8a04> Если вы считаете, что загруженный файл нарушает наши условия предоставления услуг (например, нарушает авторские права или содержит неприемлемый контент), пожалуйста, сообщите нам об этом напрямую по электронной почте <a href=\"mailto:47Poligons@gmail.com\" data-v-8efc8a04>47Poligons@gmail.com</a>. </p></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeCardsComponent = _resolveComponent("WelcomeCardsComponent")!
  const _component_TopWeekCardsComponent = _resolveComponent("TopWeekCardsComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_WelcomeCardsComponent),
    _hoisted_2,
    _createVNode(_component_TopWeekCardsComponent),
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("p", null, [
        _createTextVNode("Наш сайт регулярно обновляется, чтобы вы всегда могли находить свежие и интересные "),
        _hoisted_7,
        _createTextVNode(". Мы предлагаем "),
        _hoisted_8,
        _createTextVNode(", такие как "),
        _createVNode(_component_router_link, { to: {name: 'mods', params: { game: 'assetto-corsa' }, query: {page: 1}} }, {
          default: _withCtx(() => [
            _createTextVNode(" Assetto Corsa")
          ]),
          _: 1
        }),
        _createTextVNode(" и "),
        _createVNode(_component_router_link, { to: {name: 'mods', params: { game: 'beamng-drive' }, query: {page: 1}} }, {
          default: _withCtx(() => [
            _createTextVNode(" BeamNG Drive")
          ]),
          _: 1
        }),
        _createTextVNode("! Также вы найдете подробные инструкции по установке и использованию "),
        _hoisted_9,
        _createTextVNode(", что делает процесс максимально простым и удобным как для опытных геймеров, так и для новичков.")
      ])
    ]),
    _hoisted_10
  ], 64))
}